import React from 'react';
import './HistoryTable.css';

export default function HistoryTableRow({history_event, ndx}) 
{
    var CreatedDT = new Date(history_event.CreatedAt);

    const formattedDate = CreatedDT.toLocaleString("en-US", {
        day: "numeric",
        month: "short",
        //year: "numeric",
        hour: "numeric",
        minute: "2-digit"
      });
      
    return (
        <>
            <tr>
                <th class="history-date-col" scope="row" key={ndx}>{formattedDate}</th>
                <td>{history_event.CreatedBy}</td>
                <td>{history_event.EventDesc}</td>
            </tr>
        </>
    );
}
